import { useState, useCallback } from 'react'

export const STEPS = [
  { key: 1, label: 'Préparation' },
  { key: 2, label: 'Importation' },
  { key: 3, label: 'Finalisation' }
]

const useStepNavigation = (initialStep = 1) => {
  const [step, setStep] = useState(initialStep)

  const goToStep = useCallback(targetStep => {
    setStep(targetStep)
  }, [])

  const goBack = useCallback(() => {
    setStep(prev => Math.max(1, prev - 1))
  }, [])

  const goNext = useCallback(() => {
    setStep(prev => Math.min(STEPS.length, prev + 1))
  }, [])

  const reset = useCallback(() => {
    setStep(initialStep)
  }, [initialStep])

  return {
    step,
    goToStep,
    goBack,
    goNext,
    reset
  }
}

export default useStepNavigation
